import { ChangeDetectionStrategy, Component, computed, HostBinding, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@pc/icon';
import { ComponentSizes, PcButtonIcon } from '@pc/common';

@Component({
  selector: 'pc-entity-banner',
  standalone: true,
  imports: [CommonModule, TranslateModule, IconComponent],
  templateUrl: './entity-banner.component.html',
  styleUrl: './entity-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityBannerComponent {
  public agentName = input<string | null>(null);
  public isAgentProcess = input<boolean>(false);
  public translationText = input<string | null>(null);
  public textPosition = input<'flex-start' | 'flex-end' | 'center'>('center');
  public isDesktop = input<boolean>();
  public disclaimer = input<boolean>();
  public showClose = input<boolean>(false);
  public hideDisclaimer = output();

  public xicon = PcButtonIcon.POPUP_X_CLOSE;
  public iconSize: ComponentSizes = 'xxsmall';

  public spanClass = computed(() => {
    return this.getNeededClass();
  });

  @HostBinding('style.justify-content')
  get alignment() {
    return this.textPosition();
  }

  @HostBinding('class.x-large') get isXLarge() {
    return this.textPosition() === 'center' && this.isDesktop();
  }

  public closeDisclaimer(): void {
    this.hideDisclaimer.emit();
  }

  private getNeededClass(): string {
    let className;
    const hasDisclaimer = this.disclaimer();
    const isDesktopView = this.isDesktop();

    if (hasDisclaimer) {
      if (isDesktopView) {
        className = 'agent-entity-banner-disclaimer';
      } else {
        className = 'agent-entity-banner-disclaimer-mobile';
      }
    } else {
      if (isDesktopView) {
        className = 'agent-entity-banner';
      } else {
        className = 'agent-entity-banner';
      }
    }
    return className;
  }
}
